import { parseJson } from '@cascade/core/utils';
import type {
  TReadStorageItem,
  TStorageOptions,
  TStorageScope,
  TTextStorageOptions,
  TWriteStorageItem,
} from './storage.types.ts';

const getStorage = (scope: TStorageScope): Storage =>
  scope === 'session' ? window.sessionStorage : window.localStorage;

const readStoredText = (key: string, scope: TStorageScope) => {
  try {
    return getStorage(scope).getItem(key) ?? undefined;
  } catch {
    return undefined;
  }
};

export const readStorageItem = ((
  key: string,
  { storage = 'local', isJson }: TStorageOptions = {},
) => {
  const stored = readStoredText(key, storage);

  return isJson ? parseJson(stored) : stored;
}) as TReadStorageItem;

export const writeStorageItem: TWriteStorageItem = (
  key: string,
  value: unknown,
  { storage = 'local', isJson }: TStorageOptions = {},
): void => {
  try {
    const text = isJson ? JSON.stringify(value) : String(value);

    getStorage(storage).setItem(key, text);
  } catch {}
};

export const removeStorageItem = (
  key: string,
  { storage = 'local' }: TStorageOptions = {},
): void => {
  try {
    getStorage(storage).removeItem(key);
  } catch {}
};

export const updateStorageItem = (
  key: string,
  value?: string,
  options?: TTextStorageOptions,
): void => {
  if (value === undefined) {
    removeStorageItem(key, options);

    return;
  }

  writeStorageItem(key, value, options);
};
